import { Breakpoint } from '@altibox/design-system-component-lib';
import React from 'react';

import { i18n } from 'src/i18n';
import { selectSelectedServiceLocation, selectUserDetails } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';

import { StyledFooterText, StyledFooterUserInfo } from './footer-customer-information.styled';

export const FooterCustomerInformation = () => {
  const user = useAppSelector(selectUserDetails);
  const serviceLocation = useAppSelector(selectSelectedServiceLocation);

  if (!user) {
    return null;
  }

  return (
    <StyledFooterUserInfo>
      <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
        {user.firstName} {user.lastName}
      </StyledFooterText>
      {serviceLocation && (
        <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
          {serviceLocation.address.streetAddress} {serviceLocation.address.streetAddress2}
        </StyledFooterText>
      )}
      <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
        {i18n.component.footer.customerNumber}: {user.billingAccountId}
      </StyledFooterText>
    </StyledFooterUserInfo>
  );
};
